export default "__VITE_PUBLIC_ASSET__7f7773c6__"